import React from 'react';
import { motion } from 'framer-motion';
interface DecorativeDividerProps {
  variant?: 'simple' | 'ornate';
  onDark?: boolean;
  className?: string;
}
export function DecorativeDivider({
  variant = 'simple',
  onDark = true,
  className = ''
}: DecorativeDividerProps) {
  const lineColor = onDark ? 'bg-white/10' : 'bg-dark/10';
  const dotColor = onDark ? 'bg-accent' : 'bg-accent-dark';
  if (variant === 'ornate') {
    return <motion.div className={`flex items-center justify-center gap-4 py-6 ${className}`} initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true,
      margin: '-40px'
    }} transition={{
      duration: 0.5
    }} role="separator" aria-hidden="true" data-id="element-41">
        <div className={`h-px flex-1 max-w-[120px] ${lineColor}`} data-id="element-42" />
        <div className={`w-2 h-2 rotate-45 ${dotColor}`} data-id="element-43" />
        <div className={`h-px flex-1 max-w-[120px] ${lineColor}`} data-id="element-44" />
      </motion.div>;
  }
  return <motion.div className={`flex items-center justify-center py-6 ${className}`} initial={{
    opacity: 0
  }} whileInView={{
    opacity: 1
  }} viewport={{
    once: true,
    margin: '-40px'
  }} transition={{
    duration: 0.5
  }} role="separator" aria-hidden="true" data-id="element-45">
      <div className={`h-px w-full max-w-[200px] ${lineColor}`} data-id="element-46" />
    </motion.div>;
}